<template>
  <div class="vue-NewNativePromotionPage">
    <div
      v-if="getCurrentNativePageData ? loading : false"
      class="NewNativePromotionPage_loading"
    >
      <img src="https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fi0.hdslb.com%2Fbfs%2Farticle%2F0d31f33428da3aeb658feee1c88bbeef84f4e8cc.gif&refer=http%3A%2F%2Fi0.hdslb.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1647761330&t=6df94131c1a90503ded08226ce07d72c">
    </div>
    <NewNativePromotionPage
      v-else
      :account_id="$route.query.account_id"
      :be-based-on="$route.query.beBasedOn"
      :components="components"
      :information="information"
      :go_public="goPublic"
      :go_adq="goAdq"
    />
  </div>
</template>

<script>
import NewNativePromotionPage from './index.jsx'
import React from 'react'
import { mapGetters } from 'vuex'
import Tips1 from './components/tips1/index.jsx'
import { datas } from './datas.js'
console.log(React)

const componentsMapping = {
  TOP_IMAGE: 'top_image_comp',
  TOP_SLIDER: 'top_carousel_comp',
  TOP_VIDEO: 'top_video_comp',
  IMAGE: 'basics_image_comp',
  TEXT: 'basics_text_comp',
  FLOAT_BUTTON: 'marketing_suspension_comp'
}

export default {
  components: {
    NewNativePromotionPage
  },
  data() {
    return {
      components: [
        {
          back: '#ffffff',
          comps: [
            {
              id: Math.random(),
              name: 'Tips1',
              comp: Tips1
            }
          ]
        }
      ],
      information: {
        title: '',
        describe: '',
        name: '',
        thumbnail: {}
      },
      loading: true
    }
  },
  computed: {
    ...mapGetters(['getCurrentNativePageData'])
  },
  watch: {
    components(newComp) {
      this.loading = false
      this.components = newComp
    }
  },
  async created() {
    if (this.getCurrentNativePageData) {
      const data = this.assemblyComponentsData()
      this.information = {
        title: this.getCurrentNativePageData.share_title,
        describe: this.getCurrentNativePageData.share_desc,
        name: this.getCurrentNativePageData.canvas_name,
        common_page_id: this.getCurrentNativePageData.id,
        thumbnail: {
          path: this.getCurrentNativePageData.share_thumb_url,
          id: this.getCurrentNativePageData.share_thumb_source_id
        }
      }
      this.components = data
      this.loading = false
    }
  },
  beforeDestroy() {
    this.$store.commit('publicNativePAGE/setCurrentNativePageData', null)
    window.removeEventListener('beforeunload', this.beforeunloadHandler)
  },

  mounted() {
    window.addEventListener('beforeunload', this.beforeunloadHandler)
  },
  methods: {
    beforeunloadHandler(e) {
      e = e || window.event
      if (e) {
        e.returnValue = '您是否确认离开此页面-您输入的数据可能不会被保存'
      }
      return '您是否确认离开此页面-您输入的数据可能不会被保存'
    },

    assemblyComponentsData() {
      const pageData = JSON.parse(this.getCurrentNativePageData.canvas_info).adCanvasInfo
      const pages = pageData.PageList.Page
      const globals = pageData.globalComponentItems ? pageData.globalComponentItems.componentItem : []
      const comps = []
      for (let i = 0; i < pages.length; i++) {
        comps.push({
          back: pages[i].backgroundColor,
          comps: []
        })
        for (let l = 0; l < pages[i].componentItemList.componentItem.length; l++) {
          const item = pages[i].componentItemList.componentItem[l]
          if (item.widgetTypeV2 === 'topimg') {
            comps[i].comps.push(this.comp_top_image_comp(item))
          } else if (item.widgetTypeV2 === 'text') {
            comps[i].comps.push(this.comp_basics_text_comp(item))
          } else if (item.widgetTypeV2 === 'gh') {
            comps[i].comps.push(this.com_basics_OfficialAccount_comp(item))
          }
        }
      }

      for (let i = 0; i < globals.length; i++) {
        const item = globals[i]
        if (item.widgetTypeV2 === 'floatbutton') {
          comps[item.myIndex[0]].comps.splice(item.myIndex[1], 0, this.comp_marketing_graphic_comp(item))
        }
      }
      return comps
    },

    comp_top_image_comp(item) {
      const dItem = this.getItem('top_image_comp')
      let obj = {}
      let name = null

      if (item.adLocation === 'sns') {
        if (+item.viewType) {
          name = 'cardAdvertising'
          obj = {
            id: item.top_image_source_id,
            size: item.fileSizes,
            width: item.initWidth,
            height: item.initHeight,
            path: item.pureImageUrl,
            zwidth: Math.floor(item.initWidth / 2.133),
            zheight: Math.floor(item.initHeight / 2.13)
          }
        } else {
          name = 'regularAdvertising'
          obj = {
            id: item.top_image_source_id,
            size: item.fileSizes,
            width: item.initWidth,
            height: item.initHeight,
            path: item.pureImageUrl,
            zwidth: Math.floor(item.initWidth / 2.133),
            zheight: Math.floor(item.initHeight / 2.13)
          }
        }
      } else if (item.adLocation === 'gzh') {
        name = 'gzh'
        obj = {
          id: item.top_image_source_id,
          size: item.fileSizes,
          width: item.initWidth,
          height: item.initHeight,
          path: item.pureImageUrl,
          zwidth: Math.floor(item.initWidth / 2.133),
          zheight: Math.floor(item.initHeight / 2.13)
        }
      }

      return {
        id: Math.random(),
        name: dItem.name,
        comp: dItem.contentComp,
        copyComp: dItem.contentCopyComp,
        sideComp: dItem.sideComp,
        ifon: {
          ad_location: item.adLocation,
          outer_style: +item.viewType,
          imgeIfon: {
            sns: {
              regularAdvertising: name === 'regularAdvertising' ? obj : {},
              cardAdvertising: name === 'cardAdvertising' ? obj : {}
            },
            gzh: name === 'gzh' ? obj : {}
          }
        }
      }
    },

    comp_top_carousel_comp(datas, ifon, item, taItem) {
      ifon = { ...ifon, ...item.top_slider_spec }
      for (let ind = 0; ind < item.top_slider_spec.image_id_list.length; ind++) {
        const imgItem = this.getDataItem(datas, item.top_slider_spec.image_id_list[ind])
        ifon.image_id_list[ind] = imgItem
      }

      return {
        id: Math.random(),
        name: componentsMapping[item.element_type],
        comp: taItem.contentComp,
        copyComp: taItem.contentCopyComp,
        sideComp: taItem.sideComp,
        ifon: ifon
      }
    },

    comp_top_video_comp(datas, ifon, item, taItem) {
      ifon = { ...ifon, ...item.top_video_spec }
      const imgItem = this.getDataItem(datas, item.top_video_spec.video_id)
      if (item.top_video_spec.ad_location === 'sns') {
        if (item.top_video_spec.outer_style) {
          ifon.videoIfon.sns.cardAdvertising = imgItem
        } else {
          ifon.videoIfon.sns.regularAdvertising = imgItem
        }
      } else {
        ifon.videoIfon.gzh = imgItem
      }

      return {
        id: Math.random(),
        name: componentsMapping[item.element_type],
        comp: taItem.contentComp,
        copyComp: taItem.contentCopyComp,
        sideComp: taItem.sideComp,
        ifon: ifon
      }
    },

    comp_basics_image_comp(datas, ifon, item, taItem) {
      ifon = { ...ifon, ...item.image_spec }
      const imgItem = this.getDataItem(datas, item.image_spec.image_id)
      ifon.imageIfon = imgItem
      return {
        id: Math.random(),
        name: componentsMapping[item.element_type],
        comp: taItem.contentComp,
        copyComp: taItem.contentCopyComp,
        sideComp: taItem.sideComp,
        ifon: ifon
      }
    },

    comp_basics_text_comp(item) {
      const dItem = this.getItem('basics_text_comp')
      return {
        id: Math.random(),
        name: dItem.name,
        comp: dItem.contentComp,
        copyComp: dItem.contentCopyComp,
        sideComp: dItem.sideComp,
        ifon: {
          text: item.content,
          padding_top: item.paddingTop,
          padding_bottom: item.paddingBottom,
          font_size: +item.fontSize / 2,
          font_color: item.fontColor,
          text_alignment: +item.textAlignment,
          font_style: +item.showType
        }
      }
    },

    comp_marketing_graphic_comp(item) {
      const dItem = this.getItem('marketing_suspension_comp')
      return {
        id: Math.random(),
        name: dItem.name,
        comp: dItem.contentComp,
        copyComp: dItem.contentCopyComp,
        sideComp: dItem.sideComp,
        ifon: {
          imageIfon: {
            path: item.iconUrl ? item.iconUrl : '',
            id: item.float_image_source_id ? item.float_image_source_id : ''
          },
          style_type: item.wxad_styleType - 1,
          title: item.title,
          title_color: item.titleColor,
          desc: item.desc,
          desc_color: item.descColor,
          appear_type: 0,
          disappear_type: 0,
          forbid_page_list: [1],
          type: 9,
          myType: {
            officialAccount: {
              title: item.componentItem.btnTitle,
              font_color: item.componentItem.fontColor,
              bg_color: item.componentItem.btnBgColorTheme,
              text_alignment: item.componentItem.btnFontType,
              isFollow: item.componentItem.btnStyle
            },
            one_touch_dialing: {
              telephoneType: 0,
              ordinaryTelephone: {
                fixedLine: '',
                mobilePhone: ''
              },
              smartPhone: {
              },
              title: '立即预约',
              font_color: '#ffffff',
              bg_color: '#07C160',
              text_alignment: 0
            }
          }
        }

      }
    },

    com_basics_OfficialAccount_comp(item) {
      const dItem = this.getItem('basics_OfficialAccount_comp')

      return {
        id: Math.random(),
        name: dItem.name,
        comp: dItem.contentComp,
        copyComp: dItem.contentCopyComp,
        sideComp: dItem.sideComp,
        ifon: {
          title: item.btnTitle,
          font_color: item.fontColor,
          bg_color: item.btnBgColorTheme,
          border_color: item.btnBorderColorTheme,
          padding_top: item.paddingTop,
          padding_bottom: item.paddingBottom,
          isFollow: item.subType === '17',
          isIcon: !!+item.useIcon,
          text_alignment: +item.btnFontType,
          url: '',
          protocolType: 0
        }
      }
    },

    getItem(name) {
      for (let i = 0; i < datas.length; i++) {
        for (let l = 0; l < datas[i].data.length; l++) {
          if (datas[i].data[l].name === name) {
            return datas[i].data[l]
          }
        }
      }
    },

    getDataItem(arr, id) {
      return arr.filter((item) => {
        return item.id === id
      })[0]
    },

    goPublic() {
      this.$router.replace('/customer/publicNativePAGE/index')
    },

    goAdq(account_id) {
      this.$router.replace({
        path: '/nativePAGE/index',
        query: {
          account_id: account_id || this.$route.account_id
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.vue-NewNativePromotionPage {
  height: 100%;
  div {
    height: 100%;
  }
  .NewNativePromotionPage_loading {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
